import { render, staticRenderFns } from "./call-out-task.vue?vue&type=template&id=57402558"
import script from "./call-out-task.vue?vue&type=script&lang=ts"
export * from "./call-out-task.vue?vue&type=script&lang=ts"
import style0 from "./call-out-task.vue?vue&type=style&index=0&id=57402558&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports